import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const e = i(
  (t, r) => /* @__PURE__ */ o.jsx(
    s,
    {
      ref: r,
      ...t,
      image: (a) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...a,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M12.707 1.293a1 1 0 0 0-1.414 0l-10 10A1 1 0 0 0 1 12v2a1 1 0 0 0 1 1h2a1 1 0 0 0 .707-.293l10-10a1 1 0 0 0 0-1.414z"
            }
          )
        }
      )
    }
  )
);
e.displayName = "EditIcon";
export {
  e as EditIcon,
  e as default
};
//# sourceMappingURL=index.js.map
